import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Countries from "./../../../data/countries";
import "./purchases-history.css";
import { useNavigate } from "react-router-dom";
let PurchasesHistory = () => {
  const navigate = useNavigate();
  let TableData = [
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },

    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
    {
      date: "JAN 4, 2022, 10:04 am",
      productName: "Lorem ipsum dolor",
      sellerName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      amount: "$2000",
    },
  ];

  let State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];

  const ActionHandler = (e) => {
    if (e.target.value === "View") {
      navigate("/purchases-history/view");
    }
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={10} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by title</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by title"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">City</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Product Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Product Name"
                />
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={5} lg={5} md={5} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={5} lg={5} md={5} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="purchse-history-table-date-heading">Date</th>
                <th className="purchse-history-table-product-name-heading">
                  Product Name
                </th>
                <th className="purchse-history-table-seller-name-heading">
                  Seller Name
                </th>
                <th className="purchse-history-table-country-heading">
                  country
                </th>
                <th className="purchse-history-table-state-heading">State</th>
                <th className="purchse-history-table-city-heading">City</th>
                <th className="purchse-history-table-amount-heading">amount</th>
                <th className="purchse-history-table-status-heading"></th>
                <th className="purchse-history-table-action-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-date-data">{tableValue.date}</td>
                    <td className="table-data">{tableValue.productName}</td>
                    <td className="table-data">{tableValue.sellerName}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.city}</td>
                    <td className="table-data">{tableValue.amount}</td>
                    <td className="table-data">
                      <Button
                        className="purchse-history-table-paid-button-text"
                        variant="text"
                      >
                        Paid
                      </Button>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={ActionHandler}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default PurchasesHistory;
